import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d891ecf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center place-content-center h-full w-full z-5" }
const _hoisted_2 = { class: "dialog p-4 text-center" }
const _hoisted_3 = { class: "mb-4 text-xl font-medium" }
const _hoisted_4 = {
  class: "mt-2",
  ref: "form"
}
const _hoisted_5 = { class: "space-x-2 flex-nowrap flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormKitSchema = _resolveComponent("FormKitSchema")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _directive_motion_pop = _resolveDirective("motion-pop")!

  return (_openBlock(), _createElementBlock("div", {
    class: "absolute w-full bg-white bg-opacity-95 transition-opacity z-5",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.t("transferConversationDestinationModal.moveConversationTo", {
              channel: _ctx.channelDescription,
            })), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t("transferConversationDestinationModal.destinationExplanation", {
              channel: _ctx.channelDescription,
            })), 1),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_FormKit, {
            type: "form",
            "form-class": "py-6 px-4 space-y-6 sm:p-6",
            onSubmit: _ctx.submit,
            actions: false
          }, {
            default: _withCtx((context) => [
              _createVNode(_component_FormKitSchema, { schema: _ctx.schema }, null, 8, ["schema"]),
              _createVNode(_component_FormKit, { type: "submit" }, {
                input: _withCtx(() => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_Button, {
                      loading: context.state.loading ?? false,
                      onClick: context.node.submit
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t("shared.moveConversation")), 1)
                      ]),
                      _: 2
                    }, 1032, ["loading", "onClick"])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ], 512)
      ])), [
        [_directive_motion_pop]
      ])
    ])
  ], 4))
}